import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { ServiceRedirect, type ServiceRedirectProps } from '@bcraft-frontend-lib/payments'

import { ROUTE_URLS } from 'router/routes'

import { addNotify } from 'components/Notify'
import { Spinner } from 'components/Spinner'

export const PaymentsRedirect = () => {
  const { push } = useHistory()

  const redirectCallback = useCallback<ServiceRedirectProps['redirectCallback']>(
    (text, status) => {
      push(ROUTE_URLS.MAIN())
      addNotify(text, status)
    },
    [push],
  )

  return (
    <ServiceRedirect redirectCallback={redirectCallback}>
      <Spinner isLoading />
    </ServiceRedirect>
  )
}
